import React from 'react';
export function AnnouncementBar() {
  return <div className="fixed top-0 left-0 right-0 h-10 bg-bg-dark flex items-center justify-center z-50 px-4" data-id="element-15">
      <p className="text-white font-medium text-[11px] sm:text-[13px] tracking-wide text-center" data-id="element-16">
        🌍 Free Worldwide Shipping — Orders Dispatch in 24h
      </p>
    </div>;
}